var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5143 13.2354H12.6737V14.9264H23.5143V13.2354Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5143 17.0761H12.6737V18.767H23.5143V17.0761Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5143 20.9167H12.6737V22.6077H23.5143V20.9167Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5143 9.39478H12.6737V11.0857H23.5143V9.39478Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9821 13.2354H8.2179V14.9264H10.9821V13.2354Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9821 17.0761H8.2179V18.767H10.9821V17.0761Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9821 20.9167H8.2179V22.6077H10.9821V20.9167Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9821 9.39478H8.2179V11.0857H10.9821V9.39478Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1572 27.0038H5.84304C5.61932 27.0038 5.40477 26.9149 5.24657 26.7567C5.08838 26.5985 4.99951 26.384 4.99951 26.1602V5.84353C4.99951 5.61981 5.08838 5.40526 5.24657 5.24706C5.40477 5.08887 5.61932 5 5.84304 5H26.1572C26.3809 5 26.5954 5.08887 26.7536 5.24706C26.9118 5.40526 27.0007 5.61981 27.0007 5.84353V26.1583C27.0009 26.2692 26.9793 26.3791 26.937 26.4817C26.8948 26.5843 26.8327 26.6775 26.7543 26.756C26.676 26.8346 26.5829 26.8969 26.4804 26.9394C26.3779 26.9819 26.2681 27.0038 26.1572 27.0038ZM6.68657 25.3128H25.3091V6.6903H6.68657V25.3128Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.fa7ec9a5816a6255edc295d364087ae8.svg";
export { ForwardRef as ReactComponent };